<template>
    <div 
        class="challenge-practice-mode"
        :class="modeClass">
        <div class="challenge-practice-mode__icon"></div>
        <span class="challenge-practice-mode__label">PRATİK MODU</span>
        <span class="challenge-practice-mode__name">{{ mode.name }}</span>
        <span class="challenge-practice-mode__desc">{{ mode.description }}</span>    
    </div>
</template>
<script>
    export default {
        props: {
            mode: { type: Object, default: {
                id: 1,
                type: "phonemic-consonant",
                name: "Ünsüz Özellikleri",
                description: "Bu modda Türkçedeki ünsüzlerin üç boyutluluk özelliklerine dair olan bilgilerini test edeceksin!"
            } }
        },

        computed: {
            modeClass(){
                return 'challenge-practice-mode--' + this.mode.type;
            }
        }
    }
</script>
<style scoped src="@/css/components/challenge-practice-mode.css"></style>